/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const e=new Map;export{e as cachedStyles};
